//

export const getResetState = (editor) => editor.reset;
export const getResetSectionState = (editor) => editor.resetSection;
